import type { ReactNode } from 'react';

/** Two or three magnitudes on one scale, each bar labelled directly (identity is never colour alone). */
export function CompareBars({ rows }: { rows: { label: ReactNode; value: number; display: ReactNode; color: string }[] }) {
  const max = Math.max(...rows.map((r) => (Number.isFinite(r.value) ? r.value : 0)), 0) || 1;
  return (
    <div className="bars">
      {rows.map((r, i) => (
        <div className="bar-row" key={i}>
          <span className="soft">{r.label}</span>
          <div className="bar-track">
            <div className="bar-fill" style={{ width: `${(Math.max(0, r.value) / max) * 100}%`, background: r.color }} />
          </div>
          <b className="num">{r.display}</b>
        </div>
      ))}
    </div>
  );
}
